import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'woo-well',
  imports: [CommonModule],
  templateUrl: './well.component.html',
  styleUrl: './well.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WellComponent {
  border = input<boolean>(false);
}
